import { client } from '../config/routes'
import { Article } from '../types/entities'
import { createSlugFromUrl } from './createSlugFromUrl'

export const mapTopArticles = (articles: Article[], limit?: number) => (
  articles.slice(0, limit).map((article) => {
    const articleNameSlug = createSlugFromUrl(article.html_url)

    return ({
      id: article.id,
      url: `${client.article}/${articleNameSlug}/${article.id}`,
      title: article.title,
    })
  })
)

